import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Pagination } from '../../../../common/pagination'
import { Table } from '../../../../common/table'
import { FORMAT, formatDateTime } from '../../../../helpers/datetime'
import { tableSchema } from '../constant'
import Action from './Action'
import CheckboxAll from './CheckboxAll'
import CheckboxItem from './CheckboxItem'
import Name from './Name'
import { DEFAULT_PAGE } from './constant'
import classes from './index.module.scss'
import {
  changePage,
  changePageSize,
  selectCell,
  selectChecked,
  selectIds,
  selectPage,
  selectPageSize,
  uncheckAllItem,
} from './store/slice'

const TableTemplate = ({
  loading,
  total,
  deleteTemplate,
  openTemplate,
  updateTemplate,
}) => {
  const dispatch = useDispatch()

  const ids = useSelector(selectIds)
  const locale = useSelector((state) => state.i18n.locale)
  const checked = useSelector(selectChecked)
  const page = useSelector(selectPage)
  const pageSize = useSelector(selectPageSize)

  useEffect(() => {
    setPage(DEFAULT_PAGE)
    dispatch(uncheckAllItem())
  }, [])

  useEffect(() => {
    if (!ids.length && page !== DEFAULT_PAGE) {
      setPage(Math.max(Math.ceil(total / pageSize), DEFAULT_PAGE))
    }
  }, [ids])

  const setPage = (page) => dispatch(changePage(page))

  const setPageSize = (pageSize) => dispatch(changePageSize(pageSize))

  return (
    <Table
      ids={ids}
      columnDraggable={false}
      getDataFromRedux={selectCell}
      isLoading={loading}
      rowDraggable={false}
      hasFooter={false}
      resizable={false}
      selectedRowId={checked}
      renderPagination={() => (
        <div className={classes.mt12}>
          <Pagination {...{ page, setPage, pageSize, setPageSize, total }} />
        </div>
      )}
      schema={Object.keys(tableSchema).map((key) => {
        const title = `preferenceSetting.${key}`
        const colId =
          tableSchema[key] === tableSchema.NAME
            ? 'templateName'
            : tableSchema[key]
        const result = {
          colId,
          title,
          disableSort: true,
          tdStyle: colId === 'templateName' ? { padding: 0 } : undefined,
        }

        return {
          ...result,
          isI18n: true,
          render: [tableSchema.CREATE_AT, tableSchema.MODIFIED_AT].includes(
            colId,
          )
            ? (val) => formatDateTime(val, FORMAT.DATE, locale)
            : colId === 'templateName'
            ? (val, { rowId }) => (
                <Name
                  value={val}
                  rowId={rowId}
                  updateTemplate={updateTemplate}
                  page={page}
                  pageSize={pageSize}
                />
              )
            : colId === tableSchema.CHECKBOX
            ? (_, { rowId }) => <CheckboxItem rowId={rowId} />
            : colId === tableSchema.ACTION
            ? (_, { rowId }) => (
                <Action
                  rowId={rowId}
                  deleteTemplate={deleteTemplate}
                  openTemplate={openTemplate}
                  page={page}
                  pageSize={pageSize}
                />
              )
            : undefined,
          renderTh:
            colId === tableSchema.CHECKBOX ? () => <CheckboxAll /> : undefined,
        }
      })}
    />
  )
}

export default TableTemplate
